import { render, staticRenderFns } from "./bankList.vue?vue&type=template&id=616144af"
import script from "./bankList.vue?vue&type=script&lang=js"
export * from "./bankList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports